import axios from 'axios';
import { EventBus } from '../services/event-bus.js';
import { MUTATIONS } from './constants';
import { yoyoHttp } from '../services/http.service';
import { EVENTS } from '../store/nameConstants';

const mutations = {
    [MUTATIONS.CORE.SET_USER_DATA](state, userData) {
        state.userData = userData;
        state.userLoaded = true;
    },

    [MUTATIONS.CORE.SET_USER_BRANCH](state, userBranch) {
        state.userBranch = userBranch;
        EventBus.$emit(EVENTS.SET_USER_BRANCH, userBranch);
    },
    [MUTATIONS.CORE.SET_USER_DEFAULT_ACCOUNT](state, data) {
        const defaultCompanyAccount = data.filter((companyAccount) => {
            return companyAccount.default === true;
        })[0];

        state.companyAccountId = defaultCompanyAccount.id;
    },

    [MUTATIONS.CORE.SET_TRANSPORT_PRODUCTS](state, data) {
        state.transportProducts = data;
    },

    [MUTATIONS.CORE.SET_ACCOUNT](state, data) {
        state.companyAccountId = data;
    },

    [MUTATIONS.CORE.SET_VISIBLE_BRANCHES_FOR_USER](state, visibleBranches) {
        state.visibleBranches = visibleBranches;
    },

    [MUTATIONS.CORE.SET_COMPANY_ACCOUNTS](state, data) {
        state.companyAccounts = data;
    },
    [MUTATIONS.CORE.SET_TEST_USER](state, data) {
        state.userData.testMode = data;
    },
    [MUTATIONS.UPLOAD_DOCUMENT.SET_SHIPMENT_DOCUMENT_TYPES](state, data) {
        state.uploadDocument.shipmentDocumentTypes = data;
    },
    [MUTATIONS.CORE.SET_NEWS](state, data) {
        state.news = data;
        EventBus.$emit(EVENTS.NEWS_LOADED);
    },

    [MUTATIONS.CORE.SET_COMPANIES](state, data) {
        state.companies = data;
    },

    [MUTATIONS.CORE.SET_CUSTOMS_FREE_ZONES](state, data) {
        state.customsFreeZones = data;
    },

    [MUTATIONS.CORE.SET_SHIPMENT_SYSTEMS](state, data) {
        state.shipmentSystems = data;
    },

    [MUTATIONS.CORE.SET_CUSTOMER_TRANSACTION_ID](state, data) {
        state.customerTransactionId = data;
    },

    [MUTATIONS.CORE.SET_LOADING](state, data) {
        state.loading = data;
    },
    [MUTATIONS.CORE.SET_CURRENCY](state, data) {
        state.currencies = data;
    },

    [MUTATIONS.CORE.SET_COUNTRIES](state, data) {
        state.countries = data;
    },
    [MUTATIONS.CORE.SET_STATECODES](state, data) {
        state.stateCodes = data;
    },
    [MUTATIONS.CORE.SET_INITIALIZED](state) {
        state.initialized = true;
    },
    [MUTATIONS.CORE.SET_INCOTERMS](state, data) {
        state.incoterms = data;
    },
    [MUTATIONS.CORE.SET_EXPORT_REASON](state, data) {
        state.exportReasons = data;
    },

    [MUTATIONS.CORE.SET_HEADER_DATA](state, data) {
        state.headerData = data;
    },
    [MUTATIONS.CORE.SET_SHIPPING_SYSTEM](state, data) {
        state.shipmentSystem = data;
        yoyoHttp.setHeader("shipmentSystem",data);
    },
    [MUTATIONS.CORE.SET_SHIPMENT_ID](state, data) {
        state.shipmentId = data;
    },
    [MUTATIONS.CORE.SET_LINK_ID](state, data) {
        state.linkId = data;
    }
};

export default mutations;
